import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import {
  InvestmentTransactionProvider,
  useInvestmentTransactionContext,
} from "../../contexts/VpsTransaction";
import InvestWithdrawal from "../../components/transactions/InvestWithdrawal";
import AllocationChange from "../../components/transactions/AllocationChange";
import { Button, Modal } from "react-bootstrap";
import { numberWithCommas } from "../../utils/customFunction";
const InvestmentTransactionForm: React.FC = () => {
  return (
    <InvestmentTransactionProvider>
      <ChildComponent />
    </InvestmentTransactionProvider>
  );
};

const ChildComponent = () => {
  const {
    fields,
    updateField,
    instrumentTypes,
    loading,
    handleSubmit,
    getErrorClass,
    handleSaleDateChange,
    history,
    unitholderOptions,
    unitholderLoading,
    handleUnitholderChange,
    handleUnitholderInputChange,
    errors,
    viewMode,
    loadingViewData,
    customStyles,
    id,
    showApproval,
    authroizeDialogue,
    setAuthorizeDialogue,
    decision,
    setDecision,
    rejectReason,
    setRejectReason,
    onSubmitStatus,
    compliant,
    setCompliant,
    compliantComment,
    setcompliantComment,
    navLoading,
    updateNav,
    vpsLedgers,
  } = useInvestmentTransactionContext();

  if (viewMode === "view" && loadingViewData)
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <i
          className="fa fa-spinner fa-spin"
          style={{ fontSize: "24px", color: "#007bff" }}
        ></i>
        <div>Loading Transaction data...</div>
      </div>
    );

  return (
    <>
      <div className="content">
        <ToastContainer />

        {/* Header */}
        <div className="p-xl-3">
          <div className="input-holder mb-3">
            <h4 className="card-title">
              <i
                className="fa fa-angle-left mr-2 pointer"
                onClick={() => {
                  if (viewMode === "view") history.goBack();
                  else history.push("/admin/create-transactions-transactions");
                }}
              ></i>
              {viewMode.toUpperCase()} Transaction
            </h4>
            {viewMode !== "view" && (
              <button
                className="btn btn-info btn-sm mt-a ml-4"
                onClick={() => {
                  // history.push("/admin/post-transaction-uploader", viewMode)
                  history.replace(`/admin/post-transaction-uploader`);
                }}
              >
                <i className="fa fa-upload mr-2"></i>Upload
              </button>
            )}
          </div>
          <Row>
            {/* Instruction Details Card */}
            <Col>
              <div className="card mb-3">
                <div className="card-header text-white">
                  <h5 className="mb-0">
                    <i className="fa fa-file-text mr-2"></i>
                    Instruction Details
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Instruction Date</label>
                        <input
                          type="date"
                          className="form-control"
                          disabled={viewMode === "view"}
                          value={fields.instruction_date}
                          onChange={(e) =>
                            updateField("instruction_date", e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Settlement Date</label>
                        <input
                          type="date"
                          className="form-control"
                          disabled={viewMode === "view"}
                          value={fields.settlement_date}
                          onChange={(e) =>
                            updateField("settlement_date", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col>
              {/* Unitholder Account Details Card */}
              <div className="card mb-3">
                <div className="card-header text-white">
                  <h5 className="mb-0">
                    <i className="fa fa-user mr-2"></i>
                    Unitholder Account Details
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Search & Select Unitholder{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={unitholderOptions}
                          onChange={handleUnitholderChange}
                          onInputChange={handleUnitholderInputChange}
                          placeholder="Search by folio number or name..."
                          isDisabled={!fields.amc_code || viewMode === "view"}
                          isLoading={unitholderLoading}
                          isClearable
                          className={getErrorClass(fields.folio_no)}
                          value={
                            unitholderOptions.find(
                              (opt) => opt.folio_no === fields.folio_no
                            ) || null
                          }
                          noOptionsMessage={() =>
                            unitholderLoading
                              ? "Searching..."
                              : "No unitholders found. Try a different search."
                          }
                          filterOption={null}
                          styles={customStyles}
                        />
                        <small className="text-muted">
                          Type folio number or name to search
                        </small>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Folio Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fields.folio_no}
                          readOnly
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Unit Holder Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fields.unitholder_name}
                          readOnly
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Counter Account Title</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fields.counter_account_title}
                          onChange={(e) =>
                            updateField("counter_account_title", e.target.value)
                          }
                          placeholder="Enter counter account title"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Counter Account Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fields.counter_account_number}
                          onChange={(e) =>
                            updateField(
                              "counter_account_number",
                              e.target.value
                            )
                          }
                          placeholder="Enter counter account number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Counter Bank</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fields.counter_bank}
                          onChange={(e) =>
                            updateField("counter_bank", e.target.value)
                          }
                          placeholder="Enter counter bank"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Counter Branch</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fields.counter_branch}
                          onChange={(e) =>
                            updateField("counter_branch", e.target.value)
                          }
                          placeholder="Enter counter branch"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col className="col-md-4">
              {/* Instrument Details Card */}
              <div className="card mb-3">
                <div className="card-header text-white">
                  <h5 className="mb-0">
                    <i className="fa fa-credit-card mr-2"></i>
                    Instrument Details
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Instrument Type</label>
                        <select
                          className="form-control"
                          disabled={viewMode === "view"}
                          value={fields.instrument_type}
                          onChange={(e) =>
                            updateField("instrument_type", e.target.value)
                          }
                        >
                          <option value="">Select Type</option>
                          {instrumentTypes.map((t, i) => (
                            <option key={i} value={t}>
                              {t}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Instrument Number</label>
                        <input
                          type="text"
                          className="form-control"
                          disabled={viewMode === "view"}
                          value={fields.instrument_no}
                          onChange={(e) =>
                            updateField("instrument_no", e.target.value)
                          }
                          placeholder="Enter instrument number"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <Row>
                        <Col className="form-group">
                          <label>Sale Date</label>
                          <input
                            type="date"
                            disabled={viewMode === "view"}
                            className="form-control"
                            value={fields.sale_date}
                            onChange={(e) => {
                              updateField("sale_date", e.target.value);
                            }}
                          />
                        </Col>
                        <Col>
                          <button
                            disabled={navLoading}
                            onClick={() => updateNav()}
                            className={`btn btn-secondary mt-4`}
                          >
                            {navLoading && (
                              <i className="tim-icons  tim-icons-spin"></i>
                            )}
                            {navLoading ? "...loading" : "load"}
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <InvestWithdrawal />

          <AllocationChange />

          {vpsLedgers.length > 0 && (
            <Row>
              <Col>
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title text-primary">Ledgers</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Ledger</th>
                            <th className="text-right">Debit Amount</th>
                            <th className="text-right">Credit Amount</th>
                            <th>Type</th>
                            <th>Ledger Family</th>
                          </tr>
                        </thead>

                        <tbody>
                          {vpsLedgers?.map((item: any, index: number) => {
                            return (
                              <tr>
                                <td>
                                  <label>
                                    {item?.gl_name} <br />
                                    {item?.gl_code == "" ? (
                                      ""
                                    ) : (
                                      <small className="text-muted">
                                        ({item?.gl_code})
                                      </small>
                                    )}
                                  </label>
                                </td>
                                <td className="text-right">
                                  {numberWithCommas(item?.debit_amount)}
                                </td>
                                <td className="text-right">
                                  {numberWithCommas(item?.credit_amount)}
                                </td>
                                <td>{item?.type}</td>
                                <td>{item?.main_family_name}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                        {/* <tfoot>
                          <tr>
                            <td></td>
                            <td
                              className={
                                theme == "light"
                                  ? " text-dark " + " text-right"
                                  : " text-secondary" + " text-right"
                              }
                            >
                              Total Debit:{" "}
                              <span className="text-primary">
                                {numberWithCommas(totalDebit)}
                              </span>
                            </td>
                            <td
                              className={
                                theme == "light"
                                  ? " text-dark " + " text-right"
                                  : " text-secondary" + " text-right"
                              }
                            >
                              Total Credit:{" "}
                              <span className="text-primary">
                                {numberWithCommas(totalCredit)}
                              </span>
                            </td>
                            <td
                              className={
                                theme == "light"
                                  ? " text-dark " + " text-right"
                                  : " text-secondary" + " text-right"
                              }
                            >
                              Balance:{" "}
                              <span className="text-primary">
                                {numberWithCommas(balance)}
                              </span>
                            </td>
                          </tr>
                        </tfoot> */}
                      </table>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          {viewMode !== "view" && (
            <Row>
              {/* Submit Button */}
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 text-right">
                      <button
                        className="btn btn-secondary mr-2"
                        onClick={() =>
                          history.push(
                            "/admin/create-transactions-transactions"
                          )
                        }
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={
                          !!loading ||
                          (viewMode === "withdrawal" && !!errors.withdrawal)
                        }
                      >
                        {loading ? (
                          <>
                            <i className="fa fa-spinner fa-spin mr-2"></i>
                            Submitting...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-check mr-2"></i>
                            Submit{" "}
                            {viewMode === "withdrawal"
                              ? "Withdrawal"
                              : viewMode === "changeofallocation"
                              ? "Change of Allocation"
                              : "Investment"}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          )}

          {viewMode === "view" &&
            fields.txn_status !== "COMPLETED" &&
            showApproval && (
              <Row>
                <Button
                  className="btn btn-primary"
                  onClick={() => setAuthorizeDialogue(true)}
                >
                  Action
                </Button>
              </Row>
            )}
        </div>
      </div>

      {authroizeDialogue && (
        <Modal
          className=""
          dialogClassName="modal90w"
          show={true}
          enforceFocus={false}
          size="xl"
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setAuthorizeDialogue(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Approval Check List </h6>
          </div>
          <div className="modal-body">
            <div className="">
              <Row className="pt-3">
                <Col md="5">
                  <text className="text-primary">
                    {fields.txn_id} : {fields.txnr_type}{" "}
                  </text>{" "}
                  <text>
                    {fields.folio_no}-{fields.unitholder_name}
                  </text>
                </Col>
                <Col md="7">
                  <Row>
                    <Col md="3">
                      <FormGroup check>
                        <Label check>
                          <Input
                            checked={compliant === "compliant"}
                            type="checkbox"
                            value="compliant"
                            onChange={(e) => setCompliant(e.target.value || "")}
                          />
                          <span className="form-check-sign" />
                          Compliant
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md="2">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={compliant === "na"}
                            value="na"
                            onChange={(e: any) =>
                              setCompliant(e.target.value || "")
                            }
                          />
                          <span className="form-check-sign" />N /A
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md="7">
                      <FormGroup>
                        <input
                          type="text"
                          placeholder="Comments"
                          value={compliantComment}
                          onChange={(e) =>
                            setcompliantComment(e.target.value || "")
                          }
                          className="form-control"
                          disabled={compliant === "na"}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Decision Radio Buttons */}
              <Row className="mt-4">
                <Col md="12">
                  <FormGroup>
                    <label>Decision</label>
                    <div className="d-flex">
                      <FormGroup check className="mr-4">
                        <Label check>
                          <Input
                            type="checkbox"
                            name="decision"
                            value="accept"
                            checked={decision === "accept"}
                            onChange={(e) => {
                              setDecision(e.target.value);
                              setRejectReason(""); // Clear reject reason when accepting
                            }}
                          />
                          <span className="form-check-sign" />
                          Accept
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            name="decision"
                            value="reject"
                            checked={decision === "reject"}
                            onChange={(e) => setDecision(e.target.value)}
                          />
                          <span className="form-check-sign" />
                          Reject
                        </Label>
                      </FormGroup>
                    </div>
                  </FormGroup>
                </Col>
              </Row>

              {/* Conditional Reject Reason Textarea */}
              {decision === "reject" && (
                <Row>
                  <Col md="12">
                    <FormGroup>
                      <label>Reason for Rejection *</label>
                      <textarea
                        placeholder="Enter reason for rejection"
                        className="form-control"
                        rows={4}
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                      ></textarea>
                    </FormGroup>
                  </Col>
                </Row>
              )}

              <Row>
                <Col>
                  <div className=" ">
                    <button
                      className="btn btn-primary ml-2"
                      onClick={() => {
                        if (!decision) {
                          toast.error("Please select Accept or Reject");
                          return;
                        }
                        if (decision === "reject" && !rejectReason.trim()) {
                          toast.error("Please provide a reason for rejection");
                          return;
                        }

                        const submitData: any = {
                          txn_id: fields._id,
                          status: decision,
                        };

                        if (decision === "reject") {
                          submitData.reasons = rejectReason;
                        }
                        if (compliant === "compliant") {
                          if (!compliantComment)
                            toast.error("Please provide compliant comment");
                          submitData.compliantComment = compliantComment;
                        }
                        onSubmitStatus(submitData);

                        // Reset and close
                        setAuthorizeDialogue(false);
                        setDecision("");
                        setRejectReason("");
                        setCompliant("");
                        setcompliantComment("");
                      }}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-default"
                      onClick={() => {
                        setAuthorizeDialogue(false);
                        setDecision(""); // Reset decision
                        setRejectReason(""); // Reset reject reason
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default InvestmentTransactionForm;
